import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { User, Mail, Shield } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const AdminProfileSection = () => {
  const { admin } = useAuth();

  return (
    <div className="space-y-6 max-w-2xl" data-testid="profile-section">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold mb-2">Il Mio Profilo</h2>
        <p className="text-muted-foreground text-sm">Gestisci il tuo profilo admin</p>
      </div>

      <Card className="card-elegant">
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <div className="p-2 rounded-full bg-accent/10"><Shield className="h-5 w-5 text-accent" /></div>
            Profilo Amministratore
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label>Email</Label>
            <div className="flex items-center gap-2 mt-1">
              <Mail className="h-4 w-4 text-muted-foreground" />
              <span className="text-foreground font-medium">{admin?.email || 'evianruta2@gmail.com'}</span>
            </div>
          </div>
          <div>
            <Label>Ruolo</Label>
            <div className="flex items-center gap-2 mt-1">
              <User className="h-4 w-4 text-muted-foreground" />
              <span className="text-foreground font-medium">Amministratore</span>
            </div>
          </div>
          <div className="pt-4 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Per modificare le credenziali di accesso, contatta il supporto tecnico.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminProfileSection;
